// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"lazysizes":"b9558d30b4006064be18","flickity":"20e586ae7a532cb17839","flickity-fade":"9c88e421ab131bdba3da"}[chunkId] + ".js";
};